import React from 'react';
import { Desc, Heading, Title } from './index.styles';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { styled as styledMUI } from '@mui/material/styles';
import BasicInfo from './forms/basic-info';
import Location from './forms/location';
import { useTranslation } from 'react-i18next';
import AdditionalInfo from './forms/additional-info';
import Certifications from './forms/certifications';

export const StyledTextField = styledMUI(TextField)<TextFieldProps>`
& .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: #7E4308;
    };
  };
  & label.Mui-focused {
    color: #7E4308;
  }
`;

export interface ProductInformationProps {
  values: {
    id: number;
    name: string;
    description: string;
    development_flowcharts_description: string;
    related_documents_description: string;
    technical_documentation_description: string;
    manufacturer_name: string;
    key_company_activities: string;
    product_category_rules: string;
    revision: string;
    lca_preparation_date: string;
    valid_until: string;
    production_location: string;
    production_country: { iso_code: string };
    nace_industries: Array<{
      code: string;
    }>;
    distribution_regions: Array<{
      iso_code: string;
      name: string;
    }>;
    cpc_industry: { code: string };
    ecoinvent_version: string | null;
    image_id: string | null;
    gtin_code: string;
    gpc_code: string | null;
    ce_mark: boolean;
  };
  setValues: Function;
  basicInfoOnly?: boolean;
}

export default function ProductInformation({
  setValues,
  values,
  basicInfoOnly = false,
}: ProductInformationProps) {
  const { t } = useTranslation('lca', { keyPrefix: 'productInformation' });

  return (
    <div>
      <Title>{t('title')}</Title>
      {!basicInfoOnly && <Desc>{t('desc')}</Desc>}
      <Heading>{t('basicInformation')}</Heading>
      <BasicInfo values={values} setValues={setValues} />
      {!basicInfoOnly && (
        <>
          <Heading>{t('additionalInformation')}</Heading>
          <AdditionalInfo values={values} setValues={setValues} />
          <Heading>{t('locations')}</Heading>
          <Location values={values} setValues={setValues} />
          <Heading>{t('certifications')}</Heading>
          <Certifications values={values} setValues={setValues} />
        </>
      )}
    </div>
  );
}
